import { z } from 'zod';
import { optionalNonNegativeNumberString, optionalUuidString } from '../zod-helpers/index.js';
import { PART_CONSTRAINTS } from './constraints.js';
export const partPhysicalEditFormSchema = z.object({
    weight: optionalNonNegativeNumberString(PART_CONSTRAINTS.weight.label),
    weightUomId: optionalUuidString('Invalid weight UOM selection.'),
    len: optionalNonNegativeNumberString(PART_CONSTRAINTS.len.label),
    width: optionalNonNegativeNumberString(PART_CONSTRAINTS.width.label),
    height: optionalNonNegativeNumberString(PART_CONSTRAINTS.height.label),
    sizeUomId: optionalUuidString('Invalid size UOM selection.'),
});
//# sourceMappingURL=physical-form.js.map